import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { experienceRoles } from '../data/experience';
export function Experience() {
  return <section id="experience" className="bg-slate-50 py-24 lg:py-32" data-id="element-91" data-mp="1yu0x1ru85svm">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-92" data-mp="1tv7j5yb0zzux">
        <SectionHeading eyebrow="02. Experience" title="Roles &amp; Organizations" data-id="element-93" data-mp="1tsld633s9set" />

        <div className="mt-14 space-y-6" data-id="element-94" data-mp="2rg3uw3ffa4uy">
          {experienceRoles.map((role, index) => <motion.div key={role.organization} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1],
          delay: index * 0.08
        }} className="bg-white border border-slate-200 p-8 lg:p-10 flex flex-col sm:flex-row gap-6" data-id="element-95" data-mp="2mjv6dzfc4zb4" data-mpi={index}>
              <div className="flex h-11 w-11 items-center justify-center border border-gold/60 text-gold-dark shrink-0" data-id="element-96" data-mp="tp9h4eob50uc">
                <Briefcase className="h-5 w-5" strokeWidth={1.5} data-id="element-97" data-mp="yovt6ksegb1k" />
              </div>
              <div className="flex-1" data-id="element-98" data-mp="jrbu1ui6pa3b">
                <div className="flex flex-wrap items-baseline justify-between gap-3" data-id="element-99" data-mp="jqa5cn88wp34">
                  <h3 className="font-serif text-xl font-semibold text-navy" data-id="element-100" data-mp="op4z2k7r3y20">{role.organization}</h3>
                  <span className="text-xs font-semibold uppercase tracking-wide text-slate-500" data-id="element-101" data-mp="axqfoc9xluuf">{role.period}</span>
                </div>
                <p className="mt-1 text-sm text-slate-500" data-id="element-102" data-mp="frkvv5qbvror">{role.location}</p>
                <p className="mt-4 text-sm font-medium text-slate-800" data-id="element-103" data-mp="1258lzq0a4dt">{role.title}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-600 max-w-2xl" data-id="element-104" data-mp="60q63rdvi9yk">{role.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}